import { render, staticRenderFns } from "./RecipientMobile.vue?vue&type=template&id=037e6afb&scoped=true&"
import script from "./RecipientMobile.vue?vue&type=script&lang=js&"
export * from "./RecipientMobile.vue?vue&type=script&lang=js&"
import style0 from "./RecipientMobile.vue?vue&type=style&index=0&id=037e6afb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e6afb",
  null
  
)

export default component.exports